module.exports = __webpack_public_path__ + "79ae107b5f3342899c851890fc8ed74b.png";